var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stars)?_c('span',_vm._l((_vm.stars),function(star){return _c('i',{staticClass:"bi bi-star-fill",class:{ 'bi-star': star > _vm.rating },on:{"click":function($event){return _vm.$emit('click', { star: star })}}})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }